import React, { useContext, useCallback } from 'react';
import { TextField } from '@fluentui/react/lib/TextField';
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from '@fluentui/react/lib/DetailsList';



function IndustryList(props) {
    const industries = props.industries;
    const editedIndustry = props.editedIndustry;
    const onEditIndustry = props.onEditIndustry;
    const onUpdateIndustry = props.onUpdateIndustry;
    const onAddIndustry = props.onAddIndustry;
    const onSaveIndustries = props.onSaveIndustries;
    
    const columns = [
        { key: "column1", name: "Id", fieldName: "id", isResizable: true, minWidth: 60, maxWidth: 200 },
        {
            key: "column2",
            name: "Name",
            fieldName: "name",
            isResizable: true,
            onRender: (itm) => {
                if (itm === editedIndustry) {
                    return <TextField value={editedIndustry.name} onChange={onNameChange} />;
                }
                else {
                    return <span>{itm.name}</span>
                }
            }
        }
    ];

    const onNameChange = React.useCallback((event, newValue) => {
        editedIndustry.name = newValue;
        onUpdateIndustry(editedIndustry);
    }, [editedIndustry, onUpdateIndustry]);

    const updateSelection = useCallback(() => {
        var industryToEdit = null;
        if (_selection.count !== 0) {
            industryToEdit = _selection.getSelection()[0];
        }
        onEditIndustry(industryToEdit);
    }, [onEditIndustry]);

    const _selection = new Selection({
        onSelectionChanged: updateSelection
    });

    
    const onItemInvoked = useCallback((item) => {
        onEditIndustry(item);
    }, [onEditIndustry]);
    /*return (<h1>Test</h1>);*/
    console.log(industries);
    return (
        <DetailsList
            items={industries}
            columns={columns}
            selectionMode={SelectionMode.single}
            selection={_selection}
            itemInvoked={onItemInvoked}
        />
    );
}
export default IndustryList;